export const TosCustomer = () => {
    return (
        <>
            <h1><u>Algemene Voorwaarden Opdrachtgever </u></h1>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
            <ol>
                <li><u>Artikel 1 : Toepasselijkheid Algemene Voorwaarden Opdrachtgever</u>
                    <ul>
                        <li>De Algemene Voorwaarden Opdrachtgever zijn van toepassing op elke Opdrachtgever.</li>
                        <li>De Algemene Voorwaarden Opdrachtgever zijn permanent beschikbaar op de website van
                            Connecting Care Professionals. De Opdrachtgever moet deze aandachtig lezen, afdrukken en/of
                            downloaden en er een kopie van bewaren.
                        </li>
                        <li>Door registratie aanvaardt iedere Opdrachtgever de toepasselijkheid van de Algemene
                            Voorwaarden Opdrachtgever. Registratie op het Platform is daarom enkel mogelijk indien de
                            Opdrachtgever de Algemene Voorwaarden uitdrukkelijk aanvaardt. Na de registratie op het
                            Platform, komt tussen de Opdrachtgever en Connecting Care Professionals een overeenkomst van
                            onbepaalde duur tot stand.
                        </li>
                        <li>Deze Algemene Voorwaarden zijn essentieel voor Connecting Care Professionals voor de
                            totstandkoming van een overeenkomst tussen de Opdrachtgever en Connecting Care
                            Professionals, zodat de Opdrachtgever er zich van moet onthouden om zich te registreren en
                            toegang te nemen tot het Platform indien hij niet akkoord gaat met enige bepaling ervan.
                        </li>
                    </ul>
                </li>
            </ol>
            <p>&nbsp;</p>
            <ol start="2">
                <li><u>Artikel 2 : Aard van de verhouding tussen Connecting Care Professionals en de Opdrachtgever</u>
                    <ul>
                        <li>Deze Algemene Voorwaarden Opdrachtgever brengen geen band van ondergeschiktheid tussen
                            Connecting Care Professionals en de Opdrachtgever met zich mee.
                        </li>
                        <li>Partijen zijn volstrekt onafhankelijke entiteiten, die zelf instaan voor de juridische,
                            sociale en fiscale implicaties van de uitoefening van hun activiteiten.
                        </li>
                    </ul>
                </li>
            </ol>
            <p>Connecting Care Professionals gaat ervan uit dat er geen BTW dient te worden gerekend op de Diensten,
                gelet op hun specifieke aard. Indien de Gebruikers van mening zijn dat er toch BTW verschuldigd is,
                dient dit expliciet aan Connecting Care Professionals te worden gemeld.</p>
            <ul>
                <li>Connecting Care Professionals fungeert niet als uitzendbureau, betalend outplacementbureau of welke
                    priv&eacute;vennootschap ook met betrekking tot tewerkstelling.
                </li>
                <li>De Care Professional kan ook niet worden beschouwd als aangestelde of werknemer van Connecting Care
                    Professionals, noch oefent Connecting Care Professionals enige vorm van gezag of toezicht uit over
                    de Care Professional. Evenmin wordt de Care Professional&nbsp; door Connecting Care Professionals
                    ter beschikking gesteld aan de Zorgvrager, of vertegenwoordigt Connecting Care Professionals de Care
                    Professional/Zorgvrager.
                </li>
            </ul>
            <p>&nbsp;</p>
            <ol start="3">
                <li><u>Artikel 3 : De Dienstverlening door Connecting Care Professionals</u>
                    <ul>
                        <li>1 Beschikbaar stellen van het Platform.
                            <ul>
                                <li>Connecting Care Professionals stelt een Platform beschikbaar waarop Opdrachtgevers
                                    openstaande shiften kunnen publiceren waarvoor Care Professionals zich kunnen
                                    aanmelden. Van zodra er een bevestiging is, is de Zorgvraag niet langer zichtbaar op
                                    het Platform.
                                </li>
                                <li>Het is mogelijk dat meerdere Care Professionals zich aanmelden voor dezelfde
                                    shiften.
                                </li>
                                <li>De Opdrachtgever kiest zelf welke van de Care Professionals die zich aangemeld
                                    hebben voor de shift de Opdrachtgever het meest geschikt acht, doch is vrij om geen
                                    van de Care Professionals die zich aangemeld hebben te aanvaarden.
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ol>
            <p>Wanneer de Opdrachtgever de aanmelding van de Care Professional voor de openstaande shift aanvaardt en de
                Care Professional deze aanvaarding finaal bevestigt, ontstaat er een Bevestiging. Naar aanleiding van
                deze bevestiging, komt een Care Professional-Opdrachtgever-Overeenkomst tot stand. Hierbij krijgen beide
                partijen tevens toegang tot elkaars contactgegevens. Hoewel Connecting Care Professionals op basis van
                de informatie verstrekt via het Platform een digitale kopie van de overeenkomst beschikbaar stelt voor
                de betrokken partijen, is het zelf geen partij in de overeenkomst en draagt het geen
                verantwoordelijkheid voor de uitvoering ervan.</p>
            <ul>
                <li>Indien er een Bevestiging tot stand komt tussen de Opdrachtgever en een andere kandidaat Care
                    Professional, ontvangt de niet aanvaarde Care Professional hiervan een melding en verdwijnt de
                    Zorgvraag uit het overzicht en is deze enkel nog zichtbaar voor de betrokken Opdrachtgever en Care
                    Professional.
                </li>
            </ul>
            <ul>
                <li>Facturatie en inning van de Vergoeding Zorgvrager.
                    <ul>
                        <li>De Opdrachtgever krijgt het uurtarief van de Care Professional te zien bij elke kandidatuur.
                            De standaard gehanteerde uurtarieven per type Care Professional&nbsp; worden ter beschikking
                            gesteld via het Platform.
                        </li>
                    </ul>
                </li>
            </ul>
            <p>De vergoeding zoals bepaald in het ondernemingscontract is steeds exclusief toeslagen voor het uitvoeren
                van diensten op avonden, zaterdagen, zondagen, feestdagen en nachten. Deze vergoedingen worden als volgt
                bijkomend uitbetaald:</p>
            <ul>
                <li>20% tussen 19u en 20u (avondtoeslag)</li>
                <li>26% op zaterdag</li>
                <li>35% tussen 20u en 7u (nachttoeslag)</li>
            </ul>
            <p>(Alle nachturen na 7u worden ook met nachttoeslag uitbetaald)</p>
            <ul>
                <li>56% zon- en feestdagen</li>
                <li>50% toeslag onderbroken dienst</li>
            </ul>
            <p>Bij het plaatsen van een zorgvraag kan er indien nodig aangegeven worden of er
                pauze&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; inbegrepen is in het aantal vooropgestelde
                uren. Deze aangegeven pauze is niet betalend
                en&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; zal dus niet aangerekend worden aan
                de zorgvrager.</p>
            <ul>
                <li>De facturatie voor de uitgevoerde Diensten door de Care Professional verloopt via de Care
                    Professional die het factuur via het Platform zal versturen.
                </li>
            </ul>
            <p>Connecting Care Professionals factureert een handling fee voor de gefactureerde uren van 18%.</p>
            <ul>
                <li>De Vergoeding Care Professional wordt per vervulde Zorgvraag berekend door het Overeengekomen
                    uurtarief te vermenigvuldigen met de gepresteerde uren, zoals nader bepaald in artikel 3.2.4.
                </li>
            </ul>
            <p>Ook een vergoeding voor het materiaal dat de Care Professional dient te voorzien voor de Diensten is in
                voorkomend geval in de Vergoeding Care Professional vervat.</p>
            <ul>
                <li>Na de uitvoering van de Zorgvraag worden de gepresteerde uren bepaald als volgt:</li>
            </ul>
            <ul>
                <li>De Care Professional zal 1x per maand een factuur bezorgen van alle gepresteerde uren van die
                    maand.
                </li>
                <li>Indien noch de Care Professional, noch de Opdrachtgever de Gepresteerde uren op het platform betwist
                    binnen de 48 uren na het uitvoeren van de opdracht na afsluiting, worden de geplande uren geacht
                    gepresteerde uren te zijn, die achteraf niet meer betwist kunnen worden. Deze worden gefactureerd en
                    ge&iuml;nd zoals bepaald in artikel 3.2.5 en 3.2.6.
                </li>
                <li>Indien de Care Professional of de Opdrachtgever de Overeengekomen uren tijdig (binnen de 48uur na
                    uitvoering) betwist, dient deze ook onmiddellijk het aantal uren te corrigeren.
                </li>
                <li>De Care Professional of de Opdrachtgever ontvangt in dit geval vervolgens een e-mail van Connecting
                    Care Professionals waarin deze wordt gevraagd om het gecorrigeerde aantal uren te bevestigen of te
                    betwisten binnen de 72 uren na ontvangst.
                </li>
                <li>In geval van bevestiging, worden de gecorrigeerde uren geacht gepresteerde uren te zijn die worden
                    gefactureerd en ge&iuml;nd zoals bepaald in artikel 3.2.5 en 3.2.6. Hetzelfde geldt indien de Care
                    Professional, respectievelijk Opdrachtgever niet reageert op voormelde e-mail binnen de
                    vooropgestelde termijn en het gecorrigeerde aantal uren dus niet tijdig betwist.
                </li>
                <li>Worden de gecorrigeerde uren tijdig betwist, zullen de Opdrachtgever en de Care Professional met
                    elkaar in contact treden om de betwisting uit te klaren. Connecting Care Professionals komt in
                    voormelde betwisting niet tussen. In afwachting van een akkoord tussen Opdrachtgever en de Care
                    Professional, zal de Care Professional de uren waarover geen betwisting bestaat reeds factureren in
                    afwachting van een eventueel akkoord tussen Opdrachtgever en Care Professional. Komen de
                    Opdrachtgever en de Care Professional&nbsp; tot een akkoord over de overige uren, zullen deze uren
                    door de Care Professional worden gefactureerd.
                </li>
                <li>Facturen worden pas opgemaakt als de opdracht de status voltooid heeft.
                    <ul>
                        <li>De facturatie van de gepresteerde uren:</li>
                    </ul>
                </li>
            </ul>
            <p>De Care Professional zal alle gepresteerde uren factureren aan de Opdrachtgever en dit uiterlijk binnen
                een termijn van 14 dagen na het einde van de gepresteerde maand.</p>
            <p>Deze facturatie gebeurt conform de toepasselijke factuurvoorwaarden die de Opdrachtgever bij deze ook
                aanvaardt.</p>
            <p>De facturen dienen binnen 14 dagen na ontvangst te worden betaald. Bij niet-tijdige betaling kan de Care
                Professional&nbsp; een schadebeding aanrekenen van 10%, met een minimum van 100 EUR en interesten die 1%
                per maand bedragen toegepast op alle openstaande factuurbedragen vanaf de dag volgend op de vervaldatum
                van de betreffende factuur, indien de betaling niet tijdig is ontvangen na twee schriftelijke
                aanmaningen. Deze worden verzonden per elektronische mail. Partijen komen overeen dat voormeld
                forfaitair schadebedrag een redelijke vergoeding uitmaakt voor de re&euml;el voorzienbare schade in
                hoofde van de Care Professional.</p>
            <ul>
                <li>De inning van de gepresteerde uren door de Care Professional:</li>
            </ul>
            <p>De Care Professional zal maandelijks een factuur aan de opdrachtgever bezorgen via het platform
                Connecting Care Professionals.</p>
            <ul>
                <li>Conform de factuurvoorwaarden dient de Opdrachtgever de factuur te betalen binnen de 14 dagen na
                    ontvangst van de factuur.
                </li>
                <li>Indien de Opdrachtgever niet (tijdig of slechts gedeeltelijk) betaalt, zal Connecting Care
                    Professionals overgaan tot aanmaning(en) om alsnog tot (bij-)betaling over te gaan. Connecting Care
                    Professionals zal hiertoe tot twee schriftelijke aanmaningen versturen binnen een termijn van 2
                    maanden na de betaaldatum op de factuur. Deze aanmaningen worden verzonden via elektronische mail.
                    Indien de betaling na deze aanmaningen niet is ontvangen, behoudt Connecting Care Professionals zich
                    het recht voor om een derde aanmaning per aangetekend schrijven, uitgaande van een advocaat, te
                    versturen.
                </li>
                <li>Connecting Care Professionals behoudt zich het recht voor om in het kader van een overdracht van
                    schuldvordering van de Care Professional over te gaan tot invordering van de factuur. Desgevallend
                    zal de Opdrachtgever hiervan in kennis worden gesteld.
                </li>
                <li>De Servicevergoeding blijft in voorkomend geval nog steeds verschuldigd aan Connecting Care
                    Professionals.
                </li>
                <li>Connecting Care Professionals zal maandelijks de handling fee van 20% op het totale factuurbedrag,
                    factureren aan de klant op basis van de gepresteerde uren.
                    <ul>
                        <li>De Opdrachtgever erkent dat derden tussenkomen in het betalingsproces (bijvoorbeeld: Ogone,
                            HiPay, Paypal, Paymill, Stripe, Mollie, banken, ...). De Opdrachtgever is verplicht de
                            instructies van deze derden na te leven tijdens het betalingsproces.
                        </li>
                    </ul>
                </li>
            </ul>
            <p>&nbsp;</p>
            <ol start="4">
                <li><u>Artikel 4 : Specifieke verplichtingen van de Opdrachtgever</u>
                    <ul>
                        <li>De Opdrachtgever verbindt zich ertoe te handelen in overeenstemming met de Algemene
                            Voorwaarden en alle toepasselijke wet- en regelgeving.
                        </li>
                        <li>Het Account en het gebruik van het Platform.
                            <ul>
                                <li>Het aanmaken van het Account door de Opdrachtgever op het Platform is kosteloos.
                                </li>
                                <li>De Opdrachtgever verklaart dat de gegevens die hij/zij ingeeft bij de
                                    registratie/aanmelding juist en actueel zijn, en verbindt zich ertoe om Connecting
                                    Care Professionals van elke wijziging van deze gegevens zo snel als mogelijk op de
                                    hoogte te brengen.
                                </li>
                                <li>De Opdrachtgever verbindt zich ertoe het vertrouwelijke karakter van bepaalde
                                    gegevens te respecteren en niet door te geven aan derden (zoals diens wachtwoord,
                                    gegevens m.b.t. de betaalmiddelen, etc.). De Opdrachtgever zal de nodige
                                    veiligheidsmaatregelen nemen om die gegevens te beschermen.
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ol>
            <p>De Opdrachtgever is evenmin gerechtigd om derden gebruik te laten maken van zijn/haar Account. Indien de
                Opdrachtgever vertrouwelijke gegevens doorgeeft aan een derde, of een derde gebruik laat maken van diens
                Account kan deze van het Platform verwijderd worden.</p>
            <ul>
                <li>De Opdrachtgever verbindt zich bij het gebruik van het Platform ertoe geen wettelijke of
                    reglementaire bepalingen te schenden of inbreuk te plegen op rechten van derden.
                </li>
                <li>Om de naleving van de toepasselijke wet- en regelgeving voor de Opdrachtgever te faciliteren, kan de
                    Opdrachtgever via het Platform het Rijksregisternummer opvragen van een Care Professional, nadat met
                    de desbetreffende Care Professional een Bevestiging is tot stand gekomen. De Opdrachtgever verbindt
                    er zich uitdrukkelijk toe om het Rijksregisternummer enkel te verzamelen en te gebruiken indien dit
                    uitdrukkelijk aan de Opdrachtgever is toegestaan bij wet. De Opdrachtgever draagt hierbij tevens de
                    verantwoordelijkheid om het toepasselijke wettelijke kader betreffende gebruik van het
                    Rijksregisternummer steeds na te leven, waaronder, maar niet beperkt tot, de Wet van 8 augustus 1983
                    tot regeling van het Rijksregister van de natuurlijke personen. De Partijen erkennen en aanvaarden
                    dat Connecting Care Professionals uitsluitend optreedt op instructie en onder verantwoordelijkheid
                    van de Opdrachtgever wat betreft de verzameling van het Rijksregisternummer. Indien het
                    toepasselijke wettelijke kader aan de Opdrachtgever of aan Connecting Care Professionals bijkomende
                    plichten, formaliteiten of modaliteiten zou opleggen om de verzameling en gebruik van het
                    Rijksregisternummer via het Platform te legitimeren, verbindt de Opdrachtgever zich ertoe Connecting
                    Care Professionals hiervan onverwijld van op de hoogte te brengen en het Rijksregisternummer niet
                    verder te verzamelen en gebruiken totdat Partijen (na onderhandelingen te goeder trouw) een
                    wederzijdse overeenstemming hebben bereikt over de wijze waarop zulke bijkomende plichten,
                    formaliteiten of modaliteiten kunnen worden nageleefd.
                </li>
            </ul>
            <p>De Partijen erkennen dat de mogelijkheid om het Rijksregisternummer te verzamelen en gebruiken geen
                essentieel bestanddeel vormt van deze Algemene Voorwaarden en dat Connecting Care Professionals deze
                mogelijkheid op eender welk moment eenzijdig, zonder opgave van reden en zonder enige vergoeding
                verschuldigd te zijn aan Opdrachtgever, kan opschorten of stopzetten.</p>
            <p>De Opdrachtgever vrijwaart Connecting Care Professionals tegen alle aanspraken en alle schade die
                rechtstreeks of onrechtstreeks voortvloeit uit de verzameling en het gebruik van het Rijksregisternummer
                via het Platform door de Zorgvrager.</p>
            <ul>
                <li>De Diensten.
                    <ul>
                        <li>Indien de Care Professional zelf dient te voorzien in (verpleegkundig) materiaal voor de
                            Diensten, zal de Opdrachtgever dit duidelijk in de Zorgvraag opnemen.
                        </li>
                        <li>De Opdrachtgever staat zelf in voor de juridische, sociale en fiscale implicaties van de
                            uitoefening van de Diensten, en is verantwoordelijk voor de naleving van de toepasselijke
                            wet- en regelgeving eigen aan hun statuut en desgevallend aan het beroep. De Opdrachtgever
                            zal erover waken dat de Care Professional de Diensten steeds in veilige omstandigheden kan
                            uitvoeren.
                        </li>
                        <li>De Opdrachtgever verbindt zich ertoe dat de door de Opdrachtgever gevraagde dienst geen
                            strafbaar feit vormt volgens de wettelijke, contractuele en regelgevende bepalingen. De
                            Opdrachtgever vrijwaart Connecting Care Professionals tegen alle aanspraken van derden om
                            beroep te doen op de niet-nakoming van hun rechten.
                        </li>
                    </ul>
                </li>
                <li>Annulatie van de Zorgvraag door de Opdrachtgever.</li>
            </ul>
            <p>Het verbreken van een Bevestiging is kosteloos en zonder gevolg in volgende omstandigheden:</p>
            <ul>
                <li>De Bevestiging wordt verbroken meer dan 7 dagen voor de begindatum zoals opgenomen in de
                    Zorgvraag.
                </li>
                <li>De Bevestiging wordt verbroken minder dan 7 dagen voor aanvang van de Zorgvraag waarbij de
                    Opdrachtgever de Care Professional tijdig minimum per mail op de hoogte brengt van het verbreken van
                    de Bevestiging en waarbij de Opdrachtgever een geldig bewijs van Overmacht kan voorleggen aan
                    Connecting Care Professionals. De Opdrachtgever kan zich op overmacht beroepen indien deze
                    (tijdelijk of definitief) in de onmogelijkheid verkeert om zijn verbintenis uit te voeren door een
                    wijziging van omstandigheden die niet aan de Opdrachtgever toe te rekenen is. De Opdrachtgever dient
                    hiervoor het bewijs aan te leveren aan Connecting Care Professionals.
                </li>
            </ul>
            <p>In de volgende omstandigheden is Connecting Care Professionals gemachtigd een schadevergoeding van 100
                (honderd) euro aan te rekenen aan de Opdrachtgever bij het verbreken van een Bevestiging. Partijen komen
                overeen dat dit bedrag een redelijke vergoeding uitmaakt voor de re&euml;el voorzienbare schade in
                hoofde van Connecting Care Professionals:</p>
            <ul>
                <li>De Bevestiging wordt verbroken binnen de 7 dagen voor de begindatum zoals opgenomen in de Zorgvraag
                    waarbij geen bewijs van overmacht kan voorgelegd worden aan Connecting Care Professionals.
                </li>
                <li>De Bevestiging wordt meer dan 2x verbroken binnen de periode voor de 7 dagen voor de begindatum
                    zoals opgegeven in de Zorgvraag.
                </li>
            </ul>
            <p>Hiernaast heeft de Care Professional afzonderlijk het recht om zich rechtstreeks te richten tot de
                Opdrachtgever voor een schadevergoeding voor het verbreken van een Bevestiging indien niet voldaan werd
                aan bovengenoemde criteria.</p>
            <ul>
                <li>Annulatie door de Care Professional.
                    <ul>
                        <li>Annulatie van de opdracht door de Care Professional:</li>
                    </ul>
                </li>
            </ul>
            <p>Het verbreken van een Bevestiging is kosteloos en zonder gevolg in volgende omstandigheden:</p>
            <ul>
                <li>De Bevestiging wordt verbroken meer dan 7 dagen voor de begindatum zoals opgenomen in de
                    Zorgvraag.
                </li>
                <li>De Bevestiging wordt verbroken minder dan 7 dagen voor aanvang van de Zorgvraag waarbij de Care
                    Professional de Opdrachtgever tijdig minimum per mail op de hoogte brengt van zijn/haar afwezigheid
                    en waarbij de Care Professional een geldig ziekteattest of attest van Overmacht kan voorleggen aan
                    de Opdrachtgever en aan Connecting Care Professionals. De Care Professional kan zich op overmacht
                    beroepen indien hij/zij (tijdelijk of definitief) in de onmogelijkheid verkeert om zijn verbintenis
                    uit te voeren door een wijziging van omstandigheden die niet aan hem/haar toe te rekenen is. De Care
                    Professional&nbsp; dient hiervoor het bewijs aan te leveren aan Connecting Care Professionals.
                </li>
            </ul>
            <p>In de volgende omstandigheden is Connecting Care Professionals gemachtigd een schadevergoeding van 100
                (honderd) euro aan te rekenen aan de Care Professional bij het verbreken van een Bevestiging Partijen
                komen overeen dat dit bedrag een redelijke vergoeding uitmaakt voor de re&euml;el voorzienbare schade in
                hoofde van Connecting Care Professionals:</p>
            <ul>
                <li>De Bevestiging wordt verbroken binnen de 7 dagen voor de begindatum zoals opgenomen in de Zorgvraag
                    waarbij de Care Professional de Zorgvragen niet op de hoogte heeft gebracht of geen geldig
                    ziekteattest of attest van overmacht kan voorleggen.
                </li>
                <li>De Bevestiging wordt meer dan 2x verbroken binnen de periode voor de 7 dagen voor de begindatum
                    zoals opgegeven in de Zorgvraag.
                </li>
            </ul>
            <p>Hiernaast heeft de Opdrachtgever afzonderlijk het recht om zich rechtstreeks te richten tot de Care
                Professional voor een schadevergoeding voor het verbreken van een Bevestiging indien niet voldaan werd
                aan bovengenoemde criteria.</p>
            <p>In volgende omstandigheden is Connecting Care Professionals gemachtigd een schadevergoeding van 250
                (tweehonderdvijftig) euro aan te rekenen aan de Care Professional&nbsp; bij het verbreken van een
                Bevestiging. Partijen komen overeen dat dit bedrag een redelijke vergoeding uitmaakt voor de re&euml;el
                voorzienbare schade in hoofde van Connecting Care Professionals:</p>
            <ul>
                <li>De Bevestiging wordt verbroken zonder de Opdrachtgever en Connecting Care Professionals op de hoogte
                    te brengen waarbij de Care Professional de Diensten niet verricht.
                </li>
            </ul>
            <p>Hiernaast heeft de Opdrachtgever afzonderlijk het recht om zich rechtstreeks te richten tot de Care
                Professional&nbsp; voor een schadevergoeding voor het verbreken van een Bevestiging in bovengenoemd
                geval.</p>
            <ul>
                <li>Vroegtijdig be&euml;indigen van de opdracht door de Care Professional:</li>
            </ul>
            <p>Indien een Care Professional&nbsp; een geplande opdracht vroegtijdig be&euml;indigt zonder dat dit het
                gevolg is van noodgevallen of onverwachte omstandigheden, is Connecting Care
                Professionals &nbsp;gemachtigd de Care Professional hiervoor een fee aan te rekenen.</p>
            <p>Deze fee betreft 10%&nbsp; Excl BTW) van het vooropgestelde uurtarief x het
                aantal&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; vooropgestelde uren van de opdracht.</p>
            <p>In bovengenoemd geval zal Connecting Care Professionals een factuur opmaken van het&nbsp;&nbsp; bedrag
                gebaseerd bovenstaande berekeningswijze en deze overmaken aan de Care Professional waarbij de Care
                Professional 14 dagen tijd heeft om deze factuur te betalen. Connecting Care Professionals is tevens
                gemachtigd dit bedrag in te houden op een nog uit te voeren betaling of op een volgende Zorgvraag
                waarvoor de Care Professional&nbsp; een Bevestiging heeft.</p>
            <p>Hiernaast heeft de Opdrachtgever afzonderlijk het recht om zich rechtstreeks te richten tot de Care
                Professional voor een schadevergoeding voor het verbreken van een Bevestiging in bovengenoemd geval.</p>
            <p>Indien een Zorgvrager:</p>
            <ul>
                <li>niet langer voldoet aan de voorwaarden om zich rechtsgeldig te kunnen registreren;</li>
                <li>de veilige omstandigheden voor de uitvoering van de Zorgvraag door de Care Professional niet langer
                    kan waarborgen;
                </li>
                <li>kennis krijgt dat een Care Professional tijdelijk, dan wel definitief werd geschorst in het recht
                    diens beroep uit te oefenen ingevolge een beslissing van een daartoe bevoegd orgaan;
                </li>
                <li>kennis krijgt dat een Care Professional fysisch of psychisch niet meer in staat werd geacht om
                    zonder risico's diens beroep uit te oefenen door een hiertoe bevoegd orgaan;
                </li>
                <li>geconfronteerd wordt met problemen bij de betaling van de Vergoeding Care Professional en/of de
                    Handling Fee verbindt deze zich ertoe Connecting Care Professionals hiervan zo spoedig mogelijk in
                    te lichten. Indien de Opdrachtgever de veilige omstandigheden voor de uitvoering van de Zorgvraag
                    door de Care Professional&nbsp; niet langer kan waarborgen, zal deze de Care
                    Professional&nbsp; hiervan ook zo spoedig mogelijk inlichten.
                    <ul>
                        <li>Betaling van de Handling Fee.</li>
                    </ul>
                </li>
            </ul>
            <p>Connecting Care Professionals heeft voor de Dienstverlening recht op een vergoeding, m.n. de Handling
                Fee, dewelke wordt berekend op basis van de gepresteerde uren de Care Professional en afzonderlijk wordt
                gefactureerd aan de Opdrachtgever.</p>
            <p>Meer concreet is de Opdrachtgever per uitgevoerde Zorgvraag een Handling Fee van 18% (excl. BTW) van de
                Vergoeding Care Professional verschuldigd aan Connecting Care Professionals.</p>
            <p>Conform de factuurvoorwaarden dient de Opdrachtgever de Handling fee binnen de 14 dagen na ontvangst te
                betalen. Bij niet-tijdige betaling kan Connecting Care Professionals een schadebeding aanrekenen van
                10%, met een minimum van 60 EUR en interesten die 1% per maand bedragen toegepast op alle openstaande
                factuurbedragen vanaf de dag volgend op de vervaldatum van de betreffende factuur, indien de betaling
                niet tijdig is ontvangen na twee aanmaningen. Partijen komen overeen dat voormeld forfaitair
                schadebedrag een redelijke vergoeding uitmaakt voor de re&euml;el voorzienbare schade in hoofde van
                Connecting Care Professionals.</p>
            <ul>
                <li>Andere verplichtingen.</li>
            </ul>
            <p>De Opdrachtgever zal zich verder onthouden van de volgende handelingen:</p>
            <ul>
                <li>het omzeilen of manipuleren van het factureringsproces van Connecting Care Professionals of van de
                    Handling Fee die aan Connecting Care Professionals verschuldigd is;
                </li>
                <li>het publiceren van valse, onjuiste, misleidende of lasterlijke inhoud (inclusief de
                    Contactgegevens);
                </li>
                <li>het zich voordoen als een andere persoon/Gebruiker;</li>
                <li>het verspreiden of publiceren van ongewenste reclame op/via het Platform;</li>
                <li>het verspreiden van virussen of andere technologie&euml;n die schade kunnen berokkenen aan
                    Connecting Care Professionals of aan de belangen van de Gebruikers van
                    het&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Platform en bezoekers van de website van Connecting Care
                    Professionals;
                </li>
                <li>het verzamelen op enige manier van informatie over de Gebruikers zonder hun toelating</li>
                <li>het gebruik van de website of het Platform van Connecting Care Professionals om onwettige daden te
                    plegen of daden die verboden zijn door de Servicevoorwaarden Opdrachtgever en/of door de wet.
                </li>
                <li>elk misbruik of frauduleus gebruik van de Diensten/Dienstverlening en/of van het Platform.</li>
            </ul>
            <p>In geval van niet naleving van deze verplichting zal de Opdrachtgever per inbreuk een forfaitaire
                schadevergoeding aan Connecting Care Professionals verschuldigd zijn van &euro; 1.000,-</p>
            <p>Het voorgaande geldt onverminderd en houdt geenszins een afstand in van het recht van Connecting Care
                Professionals om een schadevergoeding te vorderen van de Opdrachtgever voor de hierdoor veroorzaakte
                re&euml;le schade in hoofde van Connecting Care Professionals, en/of te handelen conform hetgeen is
                voorzien in artikel 7 van de Servicevoorwaarden Zorgvrager.</p>
            <p>&nbsp;</p>
            <ol start="5">
                <li><u>Artikel 5 : Verantwoordelijkheid/aansprakelijkheid</u>
                    <ul>
                        <li>Connecting Care Professionals gaat ten opzichte van de Opdrachtgever slechts een
                            middelenverbintenis aan voor wat betreft de Dienstverlening.
                        </li>
                        <li>Connecting Care Professionals levert alle redelijke inspanningen opdat de website en het
                            Platform van Connecting Care Professionals steeds toegankelijk is, en deugdelijk
                            functioneert.
                        </li>
                        <li>Connecting Care Professionals kan wanneer zij het nodig acht om de kwaliteit van de
                            Dienstverlening te waarborgen, de toegang tot het Platform tijdelijk verhinderen o.a. met
                            het oog op een onderhoud.
                        </li>
                    </ul>
                </li>
            </ol>
            <p>Connecting Care Professionals levert de nodige inspanningen om deze onderbreking zo kort mogelijk te
                houden. Connecting Care Professionals kan niet verantwoordelijk worden gesteld voor welke schade ook die
                zou voortvloeien uit een onderbreking van de Dienstverlening/Diensten met het oog op het onderhoud van
                de website en het Platform.</p>
            <ul>
                <li>Een technisch probleem (bv. virus/bug, kwaadwillige indringer, etc.) of disfunctie van de website
                    van Connecting Care Professionals of het Platform en/of van de software of databases die deze bevat,
                    kan niet volledig worden uitgesloten. Connecting Care Professionals kan op geen enkele manier
                    verantwoordelijk worden gesteld voor de schade die hierdoor zou worden opgelopen door een Gebruiker.
                </li>
                <li>Indien de website of het Platform van Connecting Care Professionals hyperlinks bevat naar inhoud
                    afkomstig van derden of naar websites die door derden worden uitgebaat, is Connecting Care
                    Professionals niet aansprakelijk voor de kwaliteit of juistheid van deze inhoud of van deze
                    websites. Connecting Care Professionals kan niet worden beschouwd als onderschrijvend, publicerend
                    of toestaand van deze websites of deze inhoud.
                </li>
                <li>Connecting Care Professionals kan de gegevens die door de Gebruikers worden meegedeeld niet
                    waarborgen (bv. inhoud van de Zorgvraag, contactgegevens, diploma&rsquo;s, attesten of andere
                    kwalificaties van de Care Professional, etc.). Connecting Care Professionals controleert de gegevens
                    niet en mag er rechtmatig van uit gaan dat deze gegevens re&euml;el en correct zijn. Het komt de
                    Opdrachtgever toe deze gegevens zelf op te vragen.
                </li>
            </ul>
            <p>Connecting Care Professionals staat niet garant voor de identiteit, kwaliteit, bevoegdheid, solvabiliteit
                of het juridisch statuut van de Gebruikers, noch de juistheid, volledigheid, wettelijkheid van de door
                hen verschafte gegevens.</p>
            <ul>
                <li>Connecting Care Professionals garandeert in geen geval:</li>
            </ul>
            <ul>
                <li>dat er voor elke Zorgvraag een geschikte Care Professional wordt gevonden (invulling van een
                    Zorgvraag door een Care Professional);
                </li>
                <li>een Bevestiging;</li>
                <li>een (deugdelijke, gedeeltelijke of volledige) uitvoering van de Zorgvraag na een
                    <ul>
                        <li>Indien een Care Professional zich kandidaat stelt op basis van een incorrecte Zorgvraag,
                            geeft dit geen enkel recht op betaling of andere vergoeding door Connecting Care
                            Professionals.
                        </li>
                    </ul>
                </li>
            </ul>
            <p>Indien de informatie en/of verklaringen die in de Zorgvraag staan schade zouden berokkenen aan een Care
                Professional&nbsp; of een derde, kan Connecting Care Professionals hiervoor niet aansprakelijk worden
                gesteld. Elk bezwaar dient rechtstreeks aan de Opdrachtgever te worden gericht die verantwoordelijk is
                voor deze Zorgvraag.</p>
            <p>Connecting Care Professionals staat niet in voor de onderhandeling, inhoud, uitvoering en
                be&euml;indiging van een Zorgvraag.</p>
            <ul>
                <li>Connecting Care Professionals neemt in geen enkel geval deel aan de Care Professional
                    -Zorgvrager-Overeenkomst die ontstaat ten gevolge van de Bevestiging, en kan op geen enkele manier
                    worden verbonden door of verantwoordelijk worden gesteld voor de door de Gebruikers aangegane
                    verbintenissen in het kader daarvan.
                </li>
            </ul>
            <p>Elke Gebruiker is zelf verantwoordelijk voor de naleving van de op hen toepasselijke wetgeving en
                reglementeringen.</p>
            <ul>
                <li>De Care Professional zal zelf instaan voor de correcte uitvoering van de Diensten.</li>
            </ul>
            <p>Connecting Care Professionals zal geen enkele verantwoordelijkheid dragen voor de geleverde Diensten.</p>
            <ul>
                <li>In geval van een onderling conflict tussen Gebruikers, ontheffen de Gebruikers Connecting Care
                    Professionals van de klachten, eisen en schade van welke aard ook, die zich voordoen in het kader
                    van dan wel betrekking hebben op dergelijk conflict van welke aard ook. Indien een conflict de goede
                    werking van Connecting Care Professionals op eender welke manier belemmert of kan belemmeren, dient
                    Connecting Care Professionals door de Gebruikers te worden ingelicht over het bestaan en de aard van
                    het conflict.
                </li>
                <li>Connecting Care Professionals zal geen enkele verantwoordelijkheid dragen voor o.a. eventuele
                    vergissingen, fouten, nalatigheden, weglatingen, veroorzaakt door derden die tussenkomen in het
                    betalingsproces van de Vergoeding Care Professional.
                </li>
                <li>De Opdrachtgever verbindt er zich toe Connecting Care Professionals te vrijwaren van enig bedrag dat
                    van Connecting Care Professionals zou worden ge&euml;ist, op welke manier ook, door een derde (incl.
                    de Care Professional), met inbegrip van de belasting- of sociale zekerheidsautoriteiten.
                </li>
                <li>Indien door het RIZIV een vordering tot terugbetaling zou worden gesteld van een vergoeding
                    uitgekeerd in het kader van de ZIV-Wet en/of een geldboete zou worden opgelegd, zal deze
                    (terug)betaling niet geschieden door Connecting Care Professionals noch is enig verhaal desomtrent
                    mogelijk ten overstaan van Connecting Care Professionals.
                </li>
            </ul>
            <p>Connecting Care Professionals kan niet worden beschouwd als een met een Care
                Professional&nbsp; gelijkgestelde in de zin van de ZIV-wet.</p>
            <ul>
                <li>In het geval dat de contractuele aansprakelijkheid van Connecting Care Professionals desondanks toch
                    zou worden vastgesteld, zal de schadevergoeding in geen enkel geval een bedrag van 10% van de
                    Vergoeding Care Professional per Zorgvraag mogen overschrijden, en kan in geen enkel geval een
                    onrechtstreekse schade van welke aard ook dekken.
                </li>
            </ul>
            <p>&nbsp;</p>
            <ol start="6">
                <li><u>Artikel 6 : Opzeg en be&euml;indiging</u>
                    <ul>
                        <li>De Gebruiker kan zijn/haar Account op elk ogenblik stopzetten door zich uit te schrijven, in
                            welk geval Connecting Care Professionals het Account van de Opdrachtgever van het Platform
                            zal verwijderen nadat de Opdrachtgever en Connecting Care Professionals hun respectievelijke
                            verplichtingen uit dit artikel van de Algemene Voorwaarden Opdrachtgevers hebben voldaan. De
                            Gebruiker verstuurt hiertoe een e-mail naar administratie@connectingcareprofessionals.be met
                            de uitdrukkelijke vraag om zijn/haar Account stop te zetten.
                        </li>
                        <li>Het verwijderen van het Account heeft slechts gevolgen voor de toekomst. De respectievelijke
                            rechten en verplichtingen die voor de uitschrijving reeds waren ontstaan, zowel in hoofde
                            van de Gebruiker als in hoofde van Connecting Care Professionals, moeten onverkort worden
                            nagekomen.
                        </li>
                    </ul>
                </li>
            </ol>
            <p>De Opdrachtgever is aldus gehouden om voor alle Bevestigingen die voor de uitschrijving nog zijn ontstaan
                de Vergoedingen Care Professional en de Handling Fee te betalen aan Connecting Care Professionals.</p>
            <p>Connecting Care Professionals blijft er op haar beurt toe gehouden haar verplichtingen m.b.t. de
                facturatie en inning zoals bepaald in artikel 4 verder na te komen voor deze Bevestigingen. De
                Opdrachtgever verbindt er zich toe eventuele Zorgvragen waarvoor nog geen Bevestiging ontstaan is, en
                die de Opdrachtgever niet meer wenst in te laten vullen, bij de uitschrijving te annuleren.</p>
            <ul>
                <li>Connecting Care Professionals behoudt zich het recht voor om minstens in de hierna vermelde gevallen
                    (niet limitatief), na de Opdrachtgever hiervoor voorafgaandelijk minstens &eacute;&eacute;n keer te
                    hebben aangemaand per mail en de Opdrachtgever hieraan niet tijdig heeft geremedieerd, om de
                    Opdrachtgever de verdere toegang tot het Platform te ontzeggen:
                </li>
            </ul>
            <ul>
                <li>indien de Opdrachtgever de Algemene Voorwaarden Opdrachtgever niet respecteert;</li>
                <li>indien de Opdrachtgever over een periode van 1 jaar driemaal een Bevestiging verbreekt telkens
                    minder dan 48 uur voor de begindatum zoals opgenomen in de Zorgvraag, of een Bevestiging niet
                    verbreekt maar de Care Professional&nbsp; in de onmogelijkheid stelt de Diensten uit te voeren.
                </li>
                <li>in geval er veelvuldig klachten worden geuit door Care Professionals over (het handelen van) de
                    Opdrachtgever.
                </li>
                <li>indien de Opdrachtgever in gebreke blijft de Vergoeding(en) Care Professional en/of Handling
                    Fee&rsquo;s te voldoen aan Connecting Care Professionals;
                </li>
                <li>indien Connecting Care Professionals er kennis van krijgt dat de Opdrachtgever geen veilige en/of
                    hygi&euml;nische omstandigheden garandeert voor de Care Professionals voor
                    de&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; uitvoering van de Diensten.
                    <ul>
                        <li>Connecting Care Professionals behoudt zich het recht voor om minstens in de hierna vermelde
                            gevallen (niet limitatief), zonder aanmaning, de Opdrachtgever de verdere toegang tot het
                            Platform al dan niet tijdelijk te ontzeggen:
                        </li>
                    </ul>
                </li>
                <li>indien de Care Professional de gewijzigde Algemene Voorwaarden Opdrachtgever niet aanvaardt en
                    naleeft Connecting Care Professionals leeft in voorkomend geval haar verplichtingen nog na i.v.m. de
                    facturatie en inning van op dat ogenblik reeds uitgevoerde Diensten conform artikel 4. Ook de
                    Vergoeding Care Professional en Servicevergoeding voor deze uitgevoerde Diensten (of op dat ogenblik
                    reeds laattijdig geannuleerde Zorgvraag) blijft verschuldigd door de Zorgvrager.
                </li>
            </ul>
            <p>Eventuele op dat ogenblik geplaatste Zorgvragen of Bevestigingen komen hierdoor te vervallen zonder dat
                Connecting Care Professionals kan instaan voor eventuele nadelige gevolgen hiervan.</p>
            <ul>
                <li>Indien Connecting Care Professionals haar activiteiten stopzet, brengt Connecting Care Professionals
                    de Gebruiker hiervan zo spoedig mogelijk op de hoogte.
                </li>
            </ul>
            <p>&nbsp;</p>
            <ol start="7">
                <li><u>Artikel 7 : geen rechtstreekse contractuele overeenkomsten zonder de tussenkomst van Connecting
                    Care Professionals</u>
                    <ul>
                        <li>De Opdrachtgever verbindt zich ertoe om lopende de overeenkomst met Connecting Care
                            Professionals geen rechtstreekse arbeidsverhouding of dienstverlening aan te gaan met de
                            Care Professional voor dezelfde of een soortgelijke functie zonder tussenkomst van het
                            Platform of hieraan haar medewerking te verlenen, tenzij mits de expliciete goedkeuring van
                            Connecting Care Professionals.
                        </li>
                    </ul>
                </li>
            </ol>
            <p>Deze verplichting geldt voor de Zorgvrager, ongeacht of deze</p>
            <ul>
                <li>rechtstreeks of onrechtstreeks handelt via een verbonden vennootschap of via andere natuurlijke
                    personen, vennootschappen of rechtspersonen;
                </li>
                <li>in eigen naam optreedt of als bestuurder, vennoot of aandeelhouder van een vennootschap of een
                    andere rechtspersoon, of als werknemer, consultant of agent van een natuurlijk persoon, vennootschap
                    of een andere rechtspersoon; of
                </li>
                <li>in enige andere hoedanigheid of op enige andere wijze handelt.
                    <ul>
                        <li>De verbintenissen zoals vermeld in dit artikel 8 worden gehandhaafd lopende de Overeenkomst
                            met Connecting Care Professionals en gedurende een periode van 1 jaar te rekenen vanaf het
                            moment dat de laatste Bevestiging tot stand is gekomen tussen de betreffende Opdrachtgever
                            en Care Professional.
                        </li>
                        <li>In het kader van dit artikel 7, verklaart en aanvaardt de Opdrachtgever dat op eerste
                            verzoek van Connecting Care Professionals eventuele overeenkomsten die zonder tussenkomst
                            van het Platform werden aangegaan zullen worden overgemaakt aan Connecting Care
                            Professionals en dat op eerste verzoek van Connecting Care Professionals door de
                            Opdrachtgever een toelichting zal worden verstrekt aangaande de samenwerking die door de
                            Opdrachtgever zonder tussenkomst van het Platform werd gesloten met de Care Professional .
                        </li>
                        <li>In geval de Opdrachtgever haar verplichtingen onder dit artikel 8 schendt en na voorafgaande
                            ingebrekestelling door Connecting Care Professionals niet is overgegaan tot remedi&euml;ring
                            binnen een redelijke termijn, zal de Opdrachtgever gehouden zijn tot betaling aan Connecting
                            Care Professionals van een forfaitair bedrag van 15.000 EUR, te vermeerderen met 53 EUR per
                            dag dat dergelijke niet-nakoming blijft voortduren. Bovendien komen partijen overeen dat een
                            inbreuk door de Opdrachtgever op dit artikel 7 lopende de Overeenkomst een ernstige wanprestatie betreft in hoofde van de Opdrachtgever die de ontbinding van de Overeenkomst en de verwijdering van het Account van de Opdrachtgever rechtvaardigt.</li>
                    </ul>
                </li>
            </ul>
            <p>&nbsp;</p>
            <ol start="8">
                <li><u>Artikel 8 : Privacy en bescherming van persoonlijke gegevens</u>
                    <ul>
                        <li>Connecting Care Professionals leeft de geldende wetgeving inzake Privacy na. Voor meer informatie kan de Opdrachtgever de Privacypolicy raadplegen.</li>
                        <li>Door zich te registreren op het Platform aanvaardt de Opdrachtgever dat diens Contactgegevens worden gecommuniceerd aan de Care Professionals, en worden opgenomen in de gegevenslijst van Connecting Care Professionals.</li>
                        <li>Het is verboden voor de Gebruikers om de contactgegevens van andere Gebruikers die hij/zij via Connecting Care Professionals heeft gekregen aan andere personen te communiceren. Deze contactgegevens mogen enkel worden gebruikt door Gebruikers in de contractuele verhouding tussen beiden.</li>
                    </ul>
                </li>
            </ol>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <ol start="9">
                <li><u>Artikel 9 : Overdracht van rechten en verplichtingen</u>
                    <ul>
                        <li>Het is de Opdrachtgever verboden om diens rechten en plichten zoals vervat in deze Algemene Voorwaarden Opdrachtgever over te dragen aan derden, zonder voorafgaand uitdrukkelijk akkoord van Connecting Care Professionals.</li>
                        <li>Indien deze rechten en plichten zouden worden overgedragen, behoudt Connecting Care Professionals zich het recht voor om de Care Professional van het Platform te verwijderen na deze minstens &eacute;&eacute;n keer schriftelijk te hebben aangemaand.</li>
                    </ul>
                </li>
            </ol>
            <p>&nbsp;</p>
            <ol start="10">
                <li><u>Artikel 10 : Nietigheid</u>
                    <ul>
                        <li>De nietigheid of onafdwingbaarheid van een bepaling van deze Algemene Voorwaarden Opdrachtgever brengt op geen enkele wijze de geldigheid en afdwingbaarheid van de overige bepalingen van deze Servicevoorwaarden Opdrachtgever in het gedrang.</li>
                        <li>Desgevallend verbinden Connecting Care Professionals en de Opdrachtgever er zich toe de ongeldige bepaling te vervangen door een rechtsgeldige bepaling, die het best overeenkomt met hun gemeenschappelijke bedoeling.</li>
                    </ul>
                </li>
            </ol>
            <p>&nbsp;</p>
            <ol start="11">
                <li><u>Artikel 11 : Kennisgevingen</u></li>
            </ol>
            <p>Alle kennisgevingen gericht aan Connecting Care Professionals kunnen gebeuren via info@Connectingcareprofessionals.be.</p>
            <p>&nbsp;</p>
            <ol start="12">
                <li><u>Artikel 12 : Toepasselijk recht en bevoegdheid</u>
                    <ul>
                        <li>Deze Algemene Voorwaarden Opdrachtgever en de relatie tussen Connecting Care Professionals en de Opdrachtgever worden beheerst door en ge&iuml;nterpreteerd overeenkomstig de Belgische wetgeving.</li>
                        <li>Connecting Care Professionals en de Opdrachtgever zullen zich steeds inspannen om eventuele betwistingen minnelijk te regelen.</li>
                    </ul>
                </li>
            </ol>
            <p>Komen Connecting Care Professionals en de Opdrachtgever in geval van een geschil niet tot een minnelijk akkoord, zal het geschil uitsluitend worden behandeld voor de hoven en rechtbanken van Antwerpen.</p>
            <p>&nbsp;</p>
            <ol start="13">
                <li><u>Artikel 13 : Wijziging van de Algemene Voorwaarden Opdrachtgever</u>
                    <ul>
                        <li>Wijzigingen aan de Algemene Voorwaarden Opdrachtgever worden ter kennis gegeven aan de Opdrachtgever via de door Connecting Care Professionals gekende Contactgegevens, en op de website van Connecting Care Professionals gepubliceerd.</li>
                        <li>De Opdrachtgever zal bij het toegang nemen van zijn/haar Account worden gevraagd om deze gewijzigde Algemene voorwaarden Opdrachtgever te aanvaarden, dan wel er voor te opteren zich uit te schrijven.</li>
                    </ul>
                </li>
            </ol>
            <p>&nbsp;</p>
            <ol start="14">
                <li><u>Artikel 14 : Overmacht</u>
                    <ul>
                        <li>Connecting Care Professionals, noch de Opdrachtgever zal aansprakelijk zijn wegens vertraging of tekortkoming in de uitvoering van de verbintenissen van de Algemene Voorwaarden Opdrachtgever, indien deze vertraging of tekortkoming door overmacht in de zin van het Burgerlijk Wetboek is ontstaan.</li>
                        <li>In geval van bewezen overmacht zijn Connecting Care Professionals dan wel de Opdrachtgever gerechtigd de nakoming van hun verplichtingen geheel of gedeeltelijk op te schorten voor de duur van de overmacht, zonder tot enige schadevergoeding te kunnen worden verplicht.</li>
                        <li>Indien de periode van overmacht langer dan 3 maanden heeft geduurd, of indien reeds bij voorbaat vast staat dat die periode redelijkerwijze langer dan 3 maanden zal duren, is Connecting Care Professionals dan wel de Opdrachtgever gerechtigd deze Algemene Voorwaarden Opdrachtgever onmiddellijk bij aangetekend schrijven op te zeggen, zonder dat Connecting Care Professionals ten opzichte van de Opdrachtgever tot enige schadevergoeding gehouden is.</li>
                    </ul>
                </li>
            </ol>
        </>
    )

}

export const TosCustomerUnstyled = () => {
    return (
        <>
            <p><u>Algemene Voorwaarden Opdrachtgever </u></p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
            <ol>
                <li><u>Artikel 1 : Toepasselijkheid Algemene Voorwaarden Opdrachtgever</u>
                    <ul>
                        <li>De Algemene Voorwaarden Opdrachtgever zijn van toepassing op elke Opdrachtgever.</li>
                        <li>De Algemene Voorwaarden Opdrachtgever zijn permanent beschikbaar op de website van
                            Connecting Care Professionals. De Opdrachtgever moet deze aandachtig lezen, afdrukken en/of
                            downloaden en er een kopie van bewaren.
                        </li>
                        <li>Door registratie aanvaardt iedere Opdrachtgever de toepasselijkheid van de Algemene
                            Voorwaarden Opdrachtgever. Registratie op het Platform is daarom enkel mogelijk indien de
                            Opdrachtgever de Algemene Voorwaarden uitdrukkelijk aanvaardt. Na de registratie op het
                            Platform, komt tussen de Opdrachtgever en Connecting Care Professionals een overeenkomst van
                            onbepaalde duur tot stand.
                        </li>
                        <li>Deze Algemene Voorwaarden zijn essentieel voor Connecting Care Professionals voor de
                            totstandkoming van een overeenkomst tussen de Opdrachtgever en Connecting Care
                            Professionals, zodat de Opdrachtgever er zich van moet onthouden om zich te registreren en
                            toegang te nemen tot het Platform indien hij niet akkoord gaat met enige bepaling ervan.
                        </li>
                    </ul>
                </li>
            </ol>
            <p>&nbsp;</p>
            <ol start="2">
                <li><u>Artikel 2 : Aard van de verhouding tussen Connecting Care Professionals en de Opdrachtgever</u>
                    <ul>
                        <li>Deze Algemene Voorwaarden Opdrachtgever brengen geen band van ondergeschiktheid tussen
                            Connecting Care Professionals en de Opdrachtgever met zich mee.
                        </li>
                        <li>Partijen zijn volstrekt onafhankelijke entiteiten, die zelf instaan voor de juridische,
                            sociale en fiscale implicaties van de uitoefening van hun activiteiten.
                        </li>
                    </ul>
                </li>
            </ol>
            <p>Connecting Care Professionals gaat ervan uit dat er geen BTW dient te worden gerekend op de Diensten,
                gelet op hun specifieke aard. Indien de Gebruikers van mening zijn dat er toch BTW verschuldigd is,
                dient dit expliciet aan Connecting Care Professionals te worden gemeld.</p>
            <ul>
                <li>Connecting Care Professionals fungeert niet als uitzendbureau, betalend outplacementbureau of welke
                    priv&eacute;vennootschap ook met betrekking tot tewerkstelling.
                </li>
                <li>De Care Professional kan ook niet worden beschouwd als aangestelde of werknemer van Connecting Care
                    Professionals, noch oefent Connecting Care Professionals enige vorm van gezag of toezicht uit over
                    de Care Professional. Evenmin wordt de Care Professional&nbsp; door Connecting Care Professionals
                    ter beschikking gesteld aan de Zorgvrager, of vertegenwoordigt Connecting Care Professionals de Care
                    Professional/Zorgvrager.
                </li>
            </ul>
            <p>&nbsp;</p>
            <ol start="3">
                <li><u>Artikel 3 : De Dienstverlening door Connecting Care Professionals</u>
                    <ul>
                        <li>1 Beschikbaar stellen van het Platform.
                            <ul>
                                <li>Connecting Care Professionals stelt een Platform beschikbaar waarop Opdrachtgevers
                                    openstaande shiften kunnen publiceren waarvoor Care Professionals zich kunnen
                                    aanmelden. Van zodra er een bevestiging is, is de Zorgvraag niet langer zichtbaar op
                                    het Platform.
                                </li>
                                <li>Het is mogelijk dat meerdere Care Professionals zich aanmelden voor dezelfde
                                    shiften.
                                </li>
                                <li>De Opdrachtgever kiest zelf welke van de Care Professionals die zich aangemeld
                                    hebben voor de shift de Opdrachtgever het meest geschikt acht, doch is vrij om geen
                                    van de Care Professionals die zich aangemeld hebben te aanvaarden.
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ol>
            <p>Wanneer de Opdrachtgever de aanmelding van de Care Professional voor de openstaande shift aanvaardt en de
                Care Professional deze aanvaarding finaal bevestigt, ontstaat er een Bevestiging. Naar aanleiding van
                deze bevestiging, komt een Care Professional-Opdrachtgever-Overeenkomst tot stand. Hierbij krijgen beide
                partijen tevens toegang tot elkaars contactgegevens. Hoewel Connecting Care Professionals op basis van
                de informatie verstrekt via het Platform een digitale kopie van de overeenkomst beschikbaar stelt voor
                de betrokken partijen, is het zelf geen partij in de overeenkomst en draagt het geen
                verantwoordelijkheid voor de uitvoering ervan.</p>
            <ul>
                <li>Indien er een Bevestiging tot stand komt tussen de Opdrachtgever en een andere kandidaat Care
                    Professional, ontvangt de niet aanvaarde Care Professional hiervan een melding en verdwijnt de
                    Zorgvraag uit het overzicht en is deze enkel nog zichtbaar voor de betrokken Opdrachtgever en Care
                    Professional.
                </li>
            </ul>
            <ul>
                <li>Facturatie en inning van de Vergoeding Zorgvrager.
                    <ul>
                        <li>De Opdrachtgever krijgt het uurtarief van de Care Professional te zien bij elke kandidatuur.
                            De standaard gehanteerde uurtarieven per type Care Professional&nbsp; worden ter beschikking
                            gesteld via het Platform.
                        </li>
                    </ul>
                </li>
            </ul>
            <p>De vergoeding zoals bepaald in het ondernemingscontract is steeds exclusief toeslagen voor het uitvoeren
                van diensten op avonden, zaterdagen, zondagen, feestdagen en nachten. Deze vergoedingen worden als volgt
                bijkomend uitbetaald:</p>
            <ul>
                <li>20% tussen 19u en 20u (avondtoeslag)</li>
                <li>26% op zaterdag</li>
                <li>35% tussen 20u en 7u (nachttoeslag)</li>
            </ul>
            <p>(Alle nachturen na 7u worden ook met nachttoeslag uitbetaald)</p>
            <ul>
                <li>56% zon- en feestdagen</li>
                <li>50% toeslag onderbroken dienst</li>
            </ul>
            <p>Bij het plaatsen van een zorgvraag kan er indien nodig aangegeven worden of er
                pauze&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; inbegrepen is in het aantal vooropgestelde
                uren. Deze aangegeven pauze is niet betalend
                en&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; zal dus niet aangerekend worden aan
                de zorgvrager.</p>
            <ul>
                <li>De facturatie voor de uitgevoerde Diensten door de Care Professional verloopt via de Care
                    Professional die het factuur via het Platform zal versturen.
                </li>
            </ul>
            <p>Connecting Care Professionals factureert een handling fee voor de gefactureerde uren van 18%.</p>
            <ul>
                <li>De Vergoeding Care Professional wordt per vervulde Zorgvraag berekend door het Overeengekomen
                    uurtarief te vermenigvuldigen met de gepresteerde uren, zoals nader bepaald in artikel 3.2.4.
                </li>
            </ul>
            <p>Ook een vergoeding voor het materiaal dat de Care Professional dient te voorzien voor de Diensten is in
                voorkomend geval in de Vergoeding Care Professional vervat.</p>
            <ul>
                <li>Na de uitvoering van de Zorgvraag worden de gepresteerde uren bepaald als volgt:</li>
            </ul>
            <ul>
                <li>De Care Professional zal 1x per maand een factuur bezorgen van alle gepresteerde uren van die
                    maand.
                </li>
                <li>Indien noch de Care Professional, noch de Opdrachtgever de Gepresteerde uren op het platform betwist
                    binnen de 48 uren na het uitvoeren van de opdracht na afsluiting, worden de geplande uren geacht
                    gepresteerde uren te zijn, die achteraf niet meer betwist kunnen worden. Deze worden gefactureerd en
                    ge&iuml;nd zoals bepaald in artikel 3.2.5 en 3.2.6.
                </li>
                <li>Indien de Care Professional of de Opdrachtgever de Overeengekomen uren tijdig (binnen de 48uur na
                    uitvoering) betwist, dient deze ook onmiddellijk het aantal uren te corrigeren.
                </li>
                <li>De Care Professional of de Opdrachtgever ontvangt in dit geval vervolgens een e-mail van Connecting
                    Care Professionals waarin deze wordt gevraagd om het gecorrigeerde aantal uren te bevestigen of te
                    betwisten binnen de 72 uren na ontvangst.
                </li>
                <li>In geval van bevestiging, worden de gecorrigeerde uren geacht gepresteerde uren te zijn die worden
                    gefactureerd en ge&iuml;nd zoals bepaald in artikel 3.2.5 en 3.2.6. Hetzelfde geldt indien de Care
                    Professional, respectievelijk Opdrachtgever niet reageert op voormelde e-mail binnen de
                    vooropgestelde termijn en het gecorrigeerde aantal uren dus niet tijdig betwist.
                </li>
                <li>Worden de gecorrigeerde uren tijdig betwist, zullen de Opdrachtgever en de Care Professional met
                    elkaar in contact treden om de betwisting uit te klaren. Connecting Care Professionals komt in
                    voormelde betwisting niet tussen. In afwachting van een akkoord tussen Opdrachtgever en de Care
                    Professional, zal de Care Professional de uren waarover geen betwisting bestaat reeds factureren in
                    afwachting van een eventueel akkoord tussen Opdrachtgever en Care Professional. Komen de
                    Opdrachtgever en de Care Professional&nbsp; tot een akkoord over de overige uren, zullen deze uren
                    door de Care Professional worden gefactureerd.
                </li>
                <li>Facturen worden pas opgemaakt als de opdracht de status voltooid heeft.
                    <ul>
                        <li>De facturatie van de gepresteerde uren:</li>
                    </ul>
                </li>
            </ul>
            <p>De Care Professional zal alle gepresteerde uren factureren aan de Opdrachtgever en dit uiterlijk binnen
                een termijn van 14 dagen na het einde van de gepresteerde maand.</p>
            <p>Deze facturatie gebeurt conform de toepasselijke factuurvoorwaarden die de Opdrachtgever bij deze ook
                aanvaardt.</p>
            <p>De facturen dienen binnen 14 dagen na ontvangst te worden betaald. Bij niet-tijdige betaling kan de Care
                Professional&nbsp; een schadebeding aanrekenen van 10%, met een minimum van 100 EUR en interesten die 1%
                per maand bedragen toegepast op alle openstaande factuurbedragen vanaf de dag volgend op de vervaldatum
                van de betreffende factuur, indien de betaling niet tijdig is ontvangen na twee schriftelijke
                aanmaningen. Deze worden verzonden per elektronische mail. Partijen komen overeen dat voormeld
                forfaitair schadebedrag een redelijke vergoeding uitmaakt voor de re&euml;el voorzienbare schade in
                hoofde van de Care Professional.</p>
            <ul>
                <li>De inning van de gepresteerde uren door de Care Professional:</li>
            </ul>
            <p>De Care Professional zal maandelijks een factuur aan de opdrachtgever bezorgen via het platform
                Connecting Care Professionals.</p>
            <ul>
                <li>Conform de factuurvoorwaarden dient de Opdrachtgever de factuur te betalen binnen de 14 dagen na
                    ontvangst van de factuur.
                </li>
                <li>Indien de Opdrachtgever niet (tijdig of slechts gedeeltelijk) betaalt, zal Connecting Care
                    Professionals overgaan tot aanmaning(en) om alsnog tot (bij-)betaling over te gaan. Connecting Care
                    Professionals zal hiertoe tot twee schriftelijke aanmaningen versturen binnen een termijn van 2
                    maanden na de betaaldatum op de factuur. Deze aanmaningen worden verzonden via elektronische mail.
                    Indien de betaling na deze aanmaningen niet is ontvangen, behoudt Connecting Care Professionals zich
                    het recht voor om een derde aanmaning per aangetekend schrijven, uitgaande van een advocaat, te
                    versturen.
                </li>
                <li>Connecting Care Professionals behoudt zich het recht voor om in het kader van een overdracht van
                    schuldvordering van de Care Professional over te gaan tot invordering van de factuur. Desgevallend
                    zal de Opdrachtgever hiervan in kennis worden gesteld.
                </li>
                <li>De Servicevergoeding blijft in voorkomend geval nog steeds verschuldigd aan Connecting Care
                    Professionals.
                </li>
                <li>Connecting Care Professionals zal maandelijks de handling fee van 20% op het totale factuurbedrag,
                    factureren aan de klant op basis van de gepresteerde uren.
                    <ul>
                        <li>De Opdrachtgever erkent dat derden tussenkomen in het betalingsproces (bijvoorbeeld: Ogone,
                            HiPay, Paypal, Paymill, Stripe, Mollie, banken, ...). De Opdrachtgever is verplicht de
                            instructies van deze derden na te leven tijdens het betalingsproces.
                        </li>
                    </ul>
                </li>
            </ul>
            <p>&nbsp;</p>
            <ol start="4">
                <li><u>Artikel 4 : Specifieke verplichtingen van de Opdrachtgever</u>
                    <ul>
                        <li>De Opdrachtgever verbindt zich ertoe te handelen in overeenstemming met de Algemene
                            Voorwaarden en alle toepasselijke wet- en regelgeving.
                        </li>
                        <li>Het Account en het gebruik van het Platform.
                            <ul>
                                <li>Het aanmaken van het Account door de Opdrachtgever op het Platform is kosteloos.
                                </li>
                                <li>De Opdrachtgever verklaart dat de gegevens die hij/zij ingeeft bij de
                                    registratie/aanmelding juist en actueel zijn, en verbindt zich ertoe om Connecting
                                    Care Professionals van elke wijziging van deze gegevens zo snel als mogelijk op de
                                    hoogte te brengen.
                                </li>
                                <li>De Opdrachtgever verbindt zich ertoe het vertrouwelijke karakter van bepaalde
                                    gegevens te respecteren en niet door te geven aan derden (zoals diens wachtwoord,
                                    gegevens m.b.t. de betaalmiddelen, etc.). De Opdrachtgever zal de nodige
                                    veiligheidsmaatregelen nemen om die gegevens te beschermen.
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ol>
            <p>De Opdrachtgever is evenmin gerechtigd om derden gebruik te laten maken van zijn/haar Account. Indien de
                Opdrachtgever vertrouwelijke gegevens doorgeeft aan een derde, of een derde gebruik laat maken van diens
                Account kan deze van het Platform verwijderd worden.</p>
            <ul>
                <li>De Opdrachtgever verbindt zich bij het gebruik van het Platform ertoe geen wettelijke of
                    reglementaire bepalingen te schenden of inbreuk te plegen op rechten van derden.
                </li>
                <li>Om de naleving van de toepasselijke wet- en regelgeving voor de Opdrachtgever te faciliteren, kan de
                    Opdrachtgever via het Platform het Rijksregisternummer opvragen van een Care Professional, nadat met
                    de desbetreffende Care Professional een Bevestiging is tot stand gekomen. De Opdrachtgever verbindt
                    er zich uitdrukkelijk toe om het Rijksregisternummer enkel te verzamelen en te gebruiken indien dit
                    uitdrukkelijk aan de Opdrachtgever is toegestaan bij wet. De Opdrachtgever draagt hierbij tevens de
                    verantwoordelijkheid om het toepasselijke wettelijke kader betreffende gebruik van het
                    Rijksregisternummer steeds na te leven, waaronder, maar niet beperkt tot, de Wet van 8 augustus 1983
                    tot regeling van het Rijksregister van de natuurlijke personen. De Partijen erkennen en aanvaarden
                    dat Connecting Care Professionals uitsluitend optreedt op instructie en onder verantwoordelijkheid
                    van de Opdrachtgever wat betreft de verzameling van het Rijksregisternummer. Indien het
                    toepasselijke wettelijke kader aan de Opdrachtgever of aan Connecting Care Professionals bijkomende
                    plichten, formaliteiten of modaliteiten zou opleggen om de verzameling en gebruik van het
                    Rijksregisternummer via het Platform te legitimeren, verbindt de Opdrachtgever zich ertoe Connecting
                    Care Professionals hiervan onverwijld van op de hoogte te brengen en het Rijksregisternummer niet
                    verder te verzamelen en gebruiken totdat Partijen (na onderhandelingen te goeder trouw) een
                    wederzijdse overeenstemming hebben bereikt over de wijze waarop zulke bijkomende plichten,
                    formaliteiten of modaliteiten kunnen worden nageleefd.
                </li>
            </ul>
            <p>De Partijen erkennen dat de mogelijkheid om het Rijksregisternummer te verzamelen en gebruiken geen
                essentieel bestanddeel vormt van deze Algemene Voorwaarden en dat Connecting Care Professionals deze
                mogelijkheid op eender welk moment eenzijdig, zonder opgave van reden en zonder enige vergoeding
                verschuldigd te zijn aan Opdrachtgever, kan opschorten of stopzetten.</p>
            <p>De Opdrachtgever vrijwaart Connecting Care Professionals tegen alle aanspraken en alle schade die
                rechtstreeks of onrechtstreeks voortvloeit uit de verzameling en het gebruik van het Rijksregisternummer
                via het Platform door de Zorgvrager.</p>
            <ul>
                <li>De Diensten.
                    <ul>
                        <li>Indien de Care Professional zelf dient te voorzien in (verpleegkundig) materiaal voor de
                            Diensten, zal de Opdrachtgever dit duidelijk in de Zorgvraag opnemen.
                        </li>
                        <li>De Opdrachtgever staat zelf in voor de juridische, sociale en fiscale implicaties van de
                            uitoefening van de Diensten, en is verantwoordelijk voor de naleving van de toepasselijke
                            wet- en regelgeving eigen aan hun statuut en desgevallend aan het beroep. De Opdrachtgever
                            zal erover waken dat de Care Professional de Diensten steeds in veilige omstandigheden kan
                            uitvoeren.
                        </li>
                        <li>De Opdrachtgever verbindt zich ertoe dat de door de Opdrachtgever gevraagde dienst geen
                            strafbaar feit vormt volgens de wettelijke, contractuele en regelgevende bepalingen. De
                            Opdrachtgever vrijwaart Connecting Care Professionals tegen alle aanspraken van derden om
                            beroep te doen op de niet-nakoming van hun rechten.
                        </li>
                    </ul>
                </li>
                <li>Annulatie van de Zorgvraag door de Opdrachtgever.</li>
            </ul>
            <p>Het verbreken van een Bevestiging is kosteloos en zonder gevolg in volgende omstandigheden:</p>
            <ul>
                <li>De Bevestiging wordt verbroken meer dan 7 dagen voor de begindatum zoals opgenomen in de
                    Zorgvraag.
                </li>
                <li>De Bevestiging wordt verbroken minder dan 7 dagen voor aanvang van de Zorgvraag waarbij de
                    Opdrachtgever de Care Professional tijdig minimum per mail op de hoogte brengt van het verbreken van
                    de Bevestiging en waarbij de Opdrachtgever een geldig bewijs van Overmacht kan voorleggen aan
                    Connecting Care Professionals. De Opdrachtgever kan zich op overmacht beroepen indien deze
                    (tijdelijk of definitief) in de onmogelijkheid verkeert om zijn verbintenis uit te voeren door een
                    wijziging van omstandigheden die niet aan de Opdrachtgever toe te rekenen is. De Opdrachtgever dient
                    hiervoor het bewijs aan te leveren aan Connecting Care Professionals.
                </li>
            </ul>
            <p>In de volgende omstandigheden is Connecting Care Professionals gemachtigd een schadevergoeding van 100
                (honderd) euro aan te rekenen aan de Opdrachtgever bij het verbreken van een Bevestiging. Partijen komen
                overeen dat dit bedrag een redelijke vergoeding uitmaakt voor de re&euml;el voorzienbare schade in
                hoofde van Connecting Care Professionals:</p>
            <ul>
                <li>De Bevestiging wordt verbroken binnen de 7 dagen voor de begindatum zoals opgenomen in de Zorgvraag
                    waarbij geen bewijs van overmacht kan voorgelegd worden aan Connecting Care Professionals.
                </li>
                <li>De Bevestiging wordt meer dan 2x verbroken binnen de periode voor de 7 dagen voor de begindatum
                    zoals opgegeven in de Zorgvraag.
                </li>
            </ul>
            <p>Hiernaast heeft de Care Professional afzonderlijk het recht om zich rechtstreeks te richten tot de
                Opdrachtgever voor een schadevergoeding voor het verbreken van een Bevestiging indien niet voldaan werd
                aan bovengenoemde criteria.</p>
            <ul>
                <li>Annulatie door de Care Professional.
                    <ul>
                        <li>Annulatie van de opdracht door de Care Professional:</li>
                    </ul>
                </li>
            </ul>
            <p>Het verbreken van een Bevestiging is kosteloos en zonder gevolg in volgende omstandigheden:</p>
            <ul>
                <li>De Bevestiging wordt verbroken meer dan 7 dagen voor de begindatum zoals opgenomen in de
                    Zorgvraag.
                </li>
                <li>De Bevestiging wordt verbroken minder dan 7 dagen voor aanvang van de Zorgvraag waarbij de Care
                    Professional de Opdrachtgever tijdig minimum per mail op de hoogte brengt van zijn/haar afwezigheid
                    en waarbij de Care Professional een geldig ziekteattest of attest van Overmacht kan voorleggen aan
                    de Opdrachtgever en aan Connecting Care Professionals. De Care Professional kan zich op overmacht
                    beroepen indien hij/zij (tijdelijk of definitief) in de onmogelijkheid verkeert om zijn verbintenis
                    uit te voeren door een wijziging van omstandigheden die niet aan hem/haar toe te rekenen is. De Care
                    Professional&nbsp; dient hiervoor het bewijs aan te leveren aan Connecting Care Professionals.
                </li>
            </ul>
            <p>In de volgende omstandigheden is Connecting Care Professionals gemachtigd een schadevergoeding van 100
                (honderd) euro aan te rekenen aan de Care Professional bij het verbreken van een Bevestiging Partijen
                komen overeen dat dit bedrag een redelijke vergoeding uitmaakt voor de re&euml;el voorzienbare schade in
                hoofde van Connecting Care Professionals:</p>
            <ul>
                <li>De Bevestiging wordt verbroken binnen de 7 dagen voor de begindatum zoals opgenomen in de Zorgvraag
                    waarbij de Care Professional de Zorgvragen niet op de hoogte heeft gebracht of geen geldig
                    ziekteattest of attest van overmacht kan voorleggen.
                </li>
                <li>De Bevestiging wordt meer dan 2x verbroken binnen de periode voor de 7 dagen voor de begindatum
                    zoals opgegeven in de Zorgvraag.
                </li>
            </ul>
            <p>Hiernaast heeft de Opdrachtgever afzonderlijk het recht om zich rechtstreeks te richten tot de Care
                Professional voor een schadevergoeding voor het verbreken van een Bevestiging indien niet voldaan werd
                aan bovengenoemde criteria.</p>
            <p>In volgende omstandigheden is Connecting Care Professionals gemachtigd een schadevergoeding van 250
                (tweehonderdvijftig) euro aan te rekenen aan de Care Professional&nbsp; bij het verbreken van een
                Bevestiging. Partijen komen overeen dat dit bedrag een redelijke vergoeding uitmaakt voor de re&euml;el
                voorzienbare schade in hoofde van Connecting Care Professionals:</p>
            <ul>
                <li>De Bevestiging wordt verbroken zonder de Opdrachtgever en Connecting Care Professionals op de hoogte
                    te brengen waarbij de Care Professional de Diensten niet verricht.
                </li>
            </ul>
            <p>Hiernaast heeft de Opdrachtgever afzonderlijk het recht om zich rechtstreeks te richten tot de Care
                Professional&nbsp; voor een schadevergoeding voor het verbreken van een Bevestiging in bovengenoemd
                geval.</p>
            <ul>
                <li>Vroegtijdig be&euml;indigen van de opdracht door de Care Professional:</li>
            </ul>
            <p>Indien een Care Professional&nbsp; een geplande opdracht vroegtijdig be&euml;indigt zonder dat dit het
                gevolg is van noodgevallen of onverwachte omstandigheden, is Connecting Care
                Professionals &nbsp;gemachtigd de Care Professional hiervoor een fee aan te rekenen.</p>
            <p>Deze fee betreft 10%&nbsp; Excl BTW) van het vooropgestelde uurtarief x het
                aantal&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; vooropgestelde uren van de opdracht.</p>
            <p>In bovengenoemd geval zal Connecting Care Professionals een factuur opmaken van het&nbsp;&nbsp; bedrag
                gebaseerd bovenstaande berekeningswijze en deze overmaken aan de Care Professional waarbij de Care
                Professional 14 dagen tijd heeft om deze factuur te betalen. Connecting Care Professionals is tevens
                gemachtigd dit bedrag in te houden op een nog uit te voeren betaling of op een volgende Zorgvraag
                waarvoor de Care Professional&nbsp; een Bevestiging heeft.</p>
            <p>Hiernaast heeft de Opdrachtgever afzonderlijk het recht om zich rechtstreeks te richten tot de Care
                Professional voor een schadevergoeding voor het verbreken van een Bevestiging in bovengenoemd geval.</p>
            <p>Indien een Zorgvrager:</p>
            <ul>
                <li>niet langer voldoet aan de voorwaarden om zich rechtsgeldig te kunnen registreren;</li>
                <li>de veilige omstandigheden voor de uitvoering van de Zorgvraag door de Care Professional niet langer
                    kan waarborgen;
                </li>
                <li>kennis krijgt dat een Care Professional tijdelijk, dan wel definitief werd geschorst in het recht
                    diens beroep uit te oefenen ingevolge een beslissing van een daartoe bevoegd orgaan;
                </li>
                <li>kennis krijgt dat een Care Professional fysisch of psychisch niet meer in staat werd geacht om
                    zonder risico's diens beroep uit te oefenen door een hiertoe bevoegd orgaan;
                </li>
                <li>geconfronteerd wordt met problemen bij de betaling van de Vergoeding Care Professional en/of de
                    Handling Fee verbindt deze zich ertoe Connecting Care Professionals hiervan zo spoedig mogelijk in
                    te lichten. Indien de Opdrachtgever de veilige omstandigheden voor de uitvoering van de Zorgvraag
                    door de Care Professional&nbsp; niet langer kan waarborgen, zal deze de Care
                    Professional&nbsp; hiervan ook zo spoedig mogelijk inlichten.
                    <ul>
                        <li>Betaling van de Handling Fee.</li>
                    </ul>
                </li>
            </ul>
            <p>Connecting Care Professionals heeft voor de Dienstverlening recht op een vergoeding, m.n. de Handling
                Fee, dewelke wordt berekend op basis van de gepresteerde uren de Care Professional en afzonderlijk wordt
                gefactureerd aan de Opdrachtgever.</p>
            <p>Meer concreet is de Opdrachtgever per uitgevoerde Zorgvraag een Handling Fee van 18% (excl. BTW) van de
                Vergoeding Care Professional verschuldigd aan Connecting Care Professionals.</p>
            <p>Conform de factuurvoorwaarden dient de Opdrachtgever de Handling fee binnen de 14 dagen na ontvangst te
                betalen. Bij niet-tijdige betaling kan Connecting Care Professionals een schadebeding aanrekenen van
                10%, met een minimum van 60 EUR en interesten die 1% per maand bedragen toegepast op alle openstaande
                factuurbedragen vanaf de dag volgend op de vervaldatum van de betreffende factuur, indien de betaling
                niet tijdig is ontvangen na twee aanmaningen. Partijen komen overeen dat voormeld forfaitair
                schadebedrag een redelijke vergoeding uitmaakt voor de re&euml;el voorzienbare schade in hoofde van
                Connecting Care Professionals.</p>
            <ul>
                <li>Andere verplichtingen.</li>
            </ul>
            <p>De Opdrachtgever zal zich verder onthouden van de volgende handelingen:</p>
            <ul>
                <li>het omzeilen of manipuleren van het factureringsproces van Connecting Care Professionals of van de
                    Handling Fee die aan Connecting Care Professionals verschuldigd is;
                </li>
                <li>het publiceren van valse, onjuiste, misleidende of lasterlijke inhoud (inclusief de
                    Contactgegevens);
                </li>
                <li>het zich voordoen als een andere persoon/Gebruiker;</li>
                <li>het verspreiden of publiceren van ongewenste reclame op/via het Platform;</li>
                <li>het verspreiden van virussen of andere technologie&euml;n die schade kunnen berokkenen aan
                    Connecting Care Professionals of aan de belangen van de Gebruikers van
                    het&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Platform en bezoekers van de website van Connecting Care
                    Professionals;
                </li>
                <li>het verzamelen op enige manier van informatie over de Gebruikers zonder hun toelating</li>
                <li>het gebruik van de website of het Platform van Connecting Care Professionals om onwettige daden te
                    plegen of daden die verboden zijn door de Servicevoorwaarden Opdrachtgever en/of door de wet.
                </li>
                <li>elk misbruik of frauduleus gebruik van de Diensten/Dienstverlening en/of van het Platform.</li>
            </ul>
            <p>In geval van niet naleving van deze verplichting zal de Opdrachtgever per inbreuk een forfaitaire
                schadevergoeding aan Connecting Care Professionals verschuldigd zijn van &euro; 1.000,-</p>
            <p>Het voorgaande geldt onverminderd en houdt geenszins een afstand in van het recht van Connecting Care
                Professionals om een schadevergoeding te vorderen van de Opdrachtgever voor de hierdoor veroorzaakte
                re&euml;le schade in hoofde van Connecting Care Professionals, en/of te handelen conform hetgeen is
                voorzien in artikel 7 van de Servicevoorwaarden Zorgvrager.</p>
            <p>&nbsp;</p>
            <ol start="5">
                <li><u>Artikel 5 : Verantwoordelijkheid/aansprakelijkheid</u>
                    <ul>
                        <li>Connecting Care Professionals gaat ten opzichte van de Opdrachtgever slechts een
                            middelenverbintenis aan voor wat betreft de Dienstverlening.
                        </li>
                        <li>Connecting Care Professionals levert alle redelijke inspanningen opdat de website en het
                            Platform van Connecting Care Professionals steeds toegankelijk is, en deugdelijk
                            functioneert.
                        </li>
                        <li>Connecting Care Professionals kan wanneer zij het nodig acht om de kwaliteit van de
                            Dienstverlening te waarborgen, de toegang tot het Platform tijdelijk verhinderen o.a. met
                            het oog op een onderhoud.
                        </li>
                    </ul>
                </li>
            </ol>
            <p>Connecting Care Professionals levert de nodige inspanningen om deze onderbreking zo kort mogelijk te
                houden. Connecting Care Professionals kan niet verantwoordelijk worden gesteld voor welke schade ook die
                zou voortvloeien uit een onderbreking van de Dienstverlening/Diensten met het oog op het onderhoud van
                de website en het Platform.</p>
            <ul>
                <li>Een technisch probleem (bv. virus/bug, kwaadwillige indringer, etc.) of disfunctie van de website
                    van Connecting Care Professionals of het Platform en/of van de software of databases die deze bevat,
                    kan niet volledig worden uitgesloten. Connecting Care Professionals kan op geen enkele manier
                    verantwoordelijk worden gesteld voor de schade die hierdoor zou worden opgelopen door een Gebruiker.
                </li>
                <li>Indien de website of het Platform van Connecting Care Professionals hyperlinks bevat naar inhoud
                    afkomstig van derden of naar websites die door derden worden uitgebaat, is Connecting Care
                    Professionals niet aansprakelijk voor de kwaliteit of juistheid van deze inhoud of van deze
                    websites. Connecting Care Professionals kan niet worden beschouwd als onderschrijvend, publicerend
                    of toestaand van deze websites of deze inhoud.
                </li>
                <li>Connecting Care Professionals kan de gegevens die door de Gebruikers worden meegedeeld niet
                    waarborgen (bv. inhoud van de Zorgvraag, contactgegevens, diploma&rsquo;s, attesten of andere
                    kwalificaties van de Care Professional, etc.). Connecting Care Professionals controleert de gegevens
                    niet en mag er rechtmatig van uit gaan dat deze gegevens re&euml;el en correct zijn. Het komt de
                    Opdrachtgever toe deze gegevens zelf op te vragen.
                </li>
            </ul>
            <p>Connecting Care Professionals staat niet garant voor de identiteit, kwaliteit, bevoegdheid, solvabiliteit
                of het juridisch statuut van de Gebruikers, noch de juistheid, volledigheid, wettelijkheid van de door
                hen verschafte gegevens.</p>
            <ul>
                <li>Connecting Care Professionals garandeert in geen geval:</li>
            </ul>
            <ul>
                <li>dat er voor elke Zorgvraag een geschikte Care Professional wordt gevonden (invulling van een
                    Zorgvraag door een Care Professional);
                </li>
                <li>een Bevestiging;</li>
                <li>een (deugdelijke, gedeeltelijke of volledige) uitvoering van de Zorgvraag na een
                    <ul>
                        <li>Indien een Care Professional zich kandidaat stelt op basis van een incorrecte Zorgvraag,
                            geeft dit geen enkel recht op betaling of andere vergoeding door Connecting Care
                            Professionals.
                        </li>
                    </ul>
                </li>
            </ul>
            <p>Indien de informatie en/of verklaringen die in de Zorgvraag staan schade zouden berokkenen aan een Care
                Professional&nbsp; of een derde, kan Connecting Care Professionals hiervoor niet aansprakelijk worden
                gesteld. Elk bezwaar dient rechtstreeks aan de Opdrachtgever te worden gericht die verantwoordelijk is
                voor deze Zorgvraag.</p>
            <p>Connecting Care Professionals staat niet in voor de onderhandeling, inhoud, uitvoering en
                be&euml;indiging van een Zorgvraag.</p>
            <ul>
                <li>Connecting Care Professionals neemt in geen enkel geval deel aan de Care Professional
                    -Zorgvrager-Overeenkomst die ontstaat ten gevolge van de Bevestiging, en kan op geen enkele manier
                    worden verbonden door of verantwoordelijk worden gesteld voor de door de Gebruikers aangegane
                    verbintenissen in het kader daarvan.
                </li>
            </ul>
            <p>Elke Gebruiker is zelf verantwoordelijk voor de naleving van de op hen toepasselijke wetgeving en
                reglementeringen.</p>
            <ul>
                <li>De Care Professional zal zelf instaan voor de correcte uitvoering van de Diensten.</li>
            </ul>
            <p>Connecting Care Professionals zal geen enkele verantwoordelijkheid dragen voor de geleverde Diensten.</p>
            <ul>
                <li>In geval van een onderling conflict tussen Gebruikers, ontheffen de Gebruikers Connecting Care
                    Professionals van de klachten, eisen en schade van welke aard ook, die zich voordoen in het kader
                    van dan wel betrekking hebben op dergelijk conflict van welke aard ook. Indien een conflict de goede
                    werking van Connecting Care Professionals op eender welke manier belemmert of kan belemmeren, dient
                    Connecting Care Professionals door de Gebruikers te worden ingelicht over het bestaan en de aard van
                    het conflict.
                </li>
                <li>Connecting Care Professionals zal geen enkele verantwoordelijkheid dragen voor o.a. eventuele
                    vergissingen, fouten, nalatigheden, weglatingen, veroorzaakt door derden die tussenkomen in het
                    betalingsproces van de Vergoeding Care Professional.
                </li>
                <li>De Opdrachtgever verbindt er zich toe Connecting Care Professionals te vrijwaren van enig bedrag dat
                    van Connecting Care Professionals zou worden ge&euml;ist, op welke manier ook, door een derde (incl.
                    de Care Professional), met inbegrip van de belasting- of sociale zekerheidsautoriteiten.
                </li>
                <li>Indien door het RIZIV een vordering tot terugbetaling zou worden gesteld van een vergoeding
                    uitgekeerd in het kader van de ZIV-Wet en/of een geldboete zou worden opgelegd, zal deze
                    (terug)betaling niet geschieden door Connecting Care Professionals noch is enig verhaal desomtrent
                    mogelijk ten overstaan van Connecting Care Professionals.
                </li>
            </ul>
            <p>Connecting Care Professionals kan niet worden beschouwd als een met een Care
                Professional&nbsp; gelijkgestelde in de zin van de ZIV-wet.</p>
            <ul>
                <li>In het geval dat de contractuele aansprakelijkheid van Connecting Care Professionals desondanks toch
                    zou worden vastgesteld, zal de schadevergoeding in geen enkel geval een bedrag van 10% van de
                    Vergoeding Care Professional per Zorgvraag mogen overschrijden, en kan in geen enkel geval een
                    onrechtstreekse schade van welke aard ook dekken.
                </li>
            </ul>
            <p>&nbsp;</p>
            <ol start="6">
                <li><u>Artikel 6 : Opzeg en be&euml;indiging</u>
                    <ul>
                        <li>De Gebruiker kan zijn/haar Account op elk ogenblik stopzetten door zich uit te schrijven, in
                            welk geval Connecting Care Professionals het Account van de Opdrachtgever van het Platform
                            zal verwijderen nadat de Opdrachtgever en Connecting Care Professionals hun respectievelijke
                            verplichtingen uit dit artikel van de Algemene Voorwaarden Opdrachtgevers hebben voldaan. De
                            Gebruiker verstuurt hiertoe een e-mail naar administratie@connectingcareprofessionals.be met
                            de uitdrukkelijke vraag om zijn/haar Account stop te zetten.
                        </li>
                        <li>Het verwijderen van het Account heeft slechts gevolgen voor de toekomst. De respectievelijke
                            rechten en verplichtingen die voor de uitschrijving reeds waren ontstaan, zowel in hoofde
                            van de Gebruiker als in hoofde van Connecting Care Professionals, moeten onverkort worden
                            nagekomen.
                        </li>
                    </ul>
                </li>
            </ol>
            <p>De Opdrachtgever is aldus gehouden om voor alle Bevestigingen die voor de uitschrijving nog zijn ontstaan
                de Vergoedingen Care Professional en de Handling Fee te betalen aan Connecting Care Professionals.</p>
            <p>Connecting Care Professionals blijft er op haar beurt toe gehouden haar verplichtingen m.b.t. de
                facturatie en inning zoals bepaald in artikel 4 verder na te komen voor deze Bevestigingen. De
                Opdrachtgever verbindt er zich toe eventuele Zorgvragen waarvoor nog geen Bevestiging ontstaan is, en
                die de Opdrachtgever niet meer wenst in te laten vullen, bij de uitschrijving te annuleren.</p>
            <ul>
                <li>Connecting Care Professionals behoudt zich het recht voor om minstens in de hierna vermelde gevallen
                    (niet limitatief), na de Opdrachtgever hiervoor voorafgaandelijk minstens &eacute;&eacute;n keer te
                    hebben aangemaand per mail en de Opdrachtgever hieraan niet tijdig heeft geremedieerd, om de
                    Opdrachtgever de verdere toegang tot het Platform te ontzeggen:
                </li>
            </ul>
            <ul>
                <li>indien de Opdrachtgever de Algemene Voorwaarden Opdrachtgever niet respecteert;</li>
                <li>indien de Opdrachtgever over een periode van 1 jaar driemaal een Bevestiging verbreekt telkens
                    minder dan 48 uur voor de begindatum zoals opgenomen in de Zorgvraag, of een Bevestiging niet
                    verbreekt maar de Care Professional&nbsp; in de onmogelijkheid stelt de Diensten uit te voeren.
                </li>
                <li>in geval er veelvuldig klachten worden geuit door Care Professionals over (het handelen van) de
                    Opdrachtgever.
                </li>
                <li>indien de Opdrachtgever in gebreke blijft de Vergoeding(en) Care Professional en/of Handling
                    Fee&rsquo;s te voldoen aan Connecting Care Professionals;
                </li>
                <li>indien Connecting Care Professionals er kennis van krijgt dat de Opdrachtgever geen veilige en/of
                    hygi&euml;nische omstandigheden garandeert voor de Care Professionals voor
                    de&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; uitvoering van de Diensten.
                    <ul>
                        <li>Connecting Care Professionals behoudt zich het recht voor om minstens in de hierna vermelde
                            gevallen (niet limitatief), zonder aanmaning, de Opdrachtgever de verdere toegang tot het
                            Platform al dan niet tijdelijk te ontzeggen:
                        </li>
                    </ul>
                </li>
                <li>indien de Care Professional de gewijzigde Algemene Voorwaarden Opdrachtgever niet aanvaardt en
                    naleeft Connecting Care Professionals leeft in voorkomend geval haar verplichtingen nog na i.v.m. de
                    facturatie en inning van op dat ogenblik reeds uitgevoerde Diensten conform artikel 4. Ook de
                    Vergoeding Care Professional en Servicevergoeding voor deze uitgevoerde Diensten (of op dat ogenblik
                    reeds laattijdig geannuleerde Zorgvraag) blijft verschuldigd door de Zorgvrager.
                </li>
            </ul>
            <p>Eventuele op dat ogenblik geplaatste Zorgvragen of Bevestigingen komen hierdoor te vervallen zonder dat
                Connecting Care Professionals kan instaan voor eventuele nadelige gevolgen hiervan.</p>
            <ul>
                <li>Indien Connecting Care Professionals haar activiteiten stopzet, brengt Connecting Care Professionals
                    de Gebruiker hiervan zo spoedig mogelijk op de hoogte.
                </li>
            </ul>
            <p>&nbsp;</p>
            <ol start="7">
                <li><u>Artikel 7 : geen rechtstreekse contractuele overeenkomsten zonder de tussenkomst van Connecting
                    Care Professionals</u>
                    <ul>
                        <li>De Opdrachtgever verbindt zich ertoe om lopende de overeenkomst met Connecting Care
                            Professionals geen rechtstreekse arbeidsverhouding of dienstverlening aan te gaan met de
                            Care Professional voor dezelfde of een soortgelijke functie zonder tussenkomst van het
                            Platform of hieraan haar medewerking te verlenen, tenzij mits de expliciete goedkeuring van
                            Connecting Care Professionals.
                        </li>
                    </ul>
                </li>
            </ol>
            <p>Deze verplichting geldt voor de Zorgvrager, ongeacht of deze</p>
            <ul>
                <li>rechtstreeks of onrechtstreeks handelt via een verbonden vennootschap of via andere natuurlijke
                    personen, vennootschappen of rechtspersonen;
                </li>
                <li>in eigen naam optreedt of als bestuurder, vennoot of aandeelhouder van een vennootschap of een
                    andere rechtspersoon, of als werknemer, consultant of agent van een natuurlijk persoon, vennootschap
                    of een andere rechtspersoon; of
                </li>
                <li>in enige andere hoedanigheid of op enige andere wijze handelt.
                    <ul>
                        <li>De verbintenissen zoals vermeld in dit artikel 8 worden gehandhaafd lopende de Overeenkomst
                            met Connecting Care Professionals en gedurende een periode van 1 jaar te rekenen vanaf het
                            moment dat de laatste Bevestiging tot stand is gekomen tussen de betreffende Opdrachtgever
                            en Care Professional.
                        </li>
                        <li>In het kader van dit artikel 7, verklaart en aanvaardt de Opdrachtgever dat op eerste
                            verzoek van Connecting Care Professionals eventuele overeenkomsten die zonder tussenkomst
                            van het Platform werden aangegaan zullen worden overgemaakt aan Connecting Care
                            Professionals en dat op eerste verzoek van Connecting Care Professionals door de
                            Opdrachtgever een toelichting zal worden verstrekt aangaande de samenwerking die door de
                            Opdrachtgever zonder tussenkomst van het Platform werd gesloten met de Care Professional .
                        </li>
                        <li>In geval de Opdrachtgever haar verplichtingen onder dit artikel 8 schendt en na voorafgaande
                            ingebrekestelling door Connecting Care Professionals niet is overgegaan tot remedi&euml;ring
                            binnen een redelijke termijn, zal de Opdrachtgever gehouden zijn tot betaling aan Connecting
                            Care Professionals van een forfaitair bedrag van 15.000 EUR, te vermeerderen met 53 EUR per
                            dag dat dergelijke niet-nakoming blijft voortduren. Bovendien komen partijen overeen dat een
                            inbreuk door de Opdrachtgever op dit artikel 7 lopende de Overeenkomst een ernstige
                            wanprestatie betreft in hoofde van de Opdrachtgever die de ontbinding van de Overeenkomst en
                            de verwijdering van het Account van de Opdrachtgever rechtvaardigt.
                        </li>
                    </ul>
                </li>
            </ul>
            <p>&nbsp;</p>
            <ol start="8">
                <li><u>Artikel 8 : Privacy en bescherming van persoonlijke gegevens</u>
                    <ul>
                        <li>Connecting Care Professionals leeft de geldende wetgeving inzake Privacy na. Voor meer
                            informatie kan de Opdrachtgever de Privacypolicy raadplegen.
                        </li>
                        <li>Door zich te registreren op het Platform aanvaardt de Opdrachtgever dat diens
                            Contactgegevens worden gecommuniceerd aan de Care Professionals, en worden opgenomen in de
                            gegevenslijst van Connecting Care Professionals.
                        </li>
                        <li>Het is verboden voor de Gebruikers om de contactgegevens van andere Gebruikers die hij/zij
                            via Connecting Care Professionals heeft gekregen aan andere personen te communiceren. Deze
                            contactgegevens mogen enkel worden gebruikt door Gebruikers in de contractuele verhouding
                            tussen beiden.
                        </li>
                    </ul>
                </li>
            </ol>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <ol start="9">
                <li><u>Artikel 9 : Overdracht van rechten en verplichtingen</u>
                    <ul>
                        <li>Het is de Opdrachtgever verboden om diens rechten en plichten zoals vervat in deze Algemene
                            Voorwaarden Opdrachtgever over te dragen aan derden, zonder voorafgaand uitdrukkelijk
                            akkoord van Connecting Care Professionals.
                        </li>
                        <li>Indien deze rechten en plichten zouden worden overgedragen, behoudt Connecting Care
                            Professionals zich het recht voor om de Care Professional van het Platform te verwijderen na
                            deze minstens &eacute;&eacute;n keer schriftelijk te hebben aangemaand.
                        </li>
                    </ul>
                </li>
            </ol>
            <p>&nbsp;</p>
            <ol start="10">
                <li><u>Artikel 10 : Nietigheid</u>
                    <ul>
                        <li>De nietigheid of onafdwingbaarheid van een bepaling van deze Algemene Voorwaarden
                            Opdrachtgever brengt op geen enkele wijze de geldigheid en afdwingbaarheid van de overige
                            bepalingen van deze Servicevoorwaarden Opdrachtgever in het gedrang.
                        </li>
                        <li>Desgevallend verbinden Connecting Care Professionals en de Opdrachtgever er zich toe de
                            ongeldige bepaling te vervangen door een rechtsgeldige bepaling, die het best overeenkomt
                            met hun gemeenschappelijke bedoeling.
                        </li>
                    </ul>
                </li>
            </ol>
            <p>&nbsp;</p>
            <ol start="11">
                <li><u>Artikel 11 : Kennisgevingen</u></li>
            </ol>
            <p>Alle kennisgevingen gericht aan Connecting Care Professionals kunnen gebeuren via
                info@Connectingcareprofessionals.be.</p>
            <p>&nbsp;</p>
            <ol start="12">
                <li><u>Artikel 12 : Toepasselijk recht en bevoegdheid</u>
                    <ul>
                        <li>Deze Algemene Voorwaarden Opdrachtgever en de relatie tussen Connecting Care Professionals
                            en de Opdrachtgever worden beheerst door en ge&iuml;nterpreteerd overeenkomstig de Belgische
                            wetgeving.
                        </li>
                        <li>Connecting Care Professionals en de Opdrachtgever zullen zich steeds inspannen om eventuele
                            betwistingen minnelijk te regelen.
                        </li>
                    </ul>
                </li>
            </ol>
            <p>Komen Connecting Care Professionals en de Opdrachtgever in geval van een geschil niet tot een minnelijk
                akkoord, zal het geschil uitsluitend worden behandeld voor de hoven en rechtbanken van Antwerpen.</p>
            <p>&nbsp;</p>
            <ol start="13">
                <li><u>Artikel 13 : Wijziging van de Algemene Voorwaarden Opdrachtgever</u>
                    <ul>
                        <li>Wijzigingen aan de Algemene Voorwaarden Opdrachtgever worden ter kennis gegeven aan de
                            Opdrachtgever via de door Connecting Care Professionals gekende Contactgegevens, en op de
                            website van Connecting Care Professionals gepubliceerd.
                        </li>
                        <li>De Opdrachtgever zal bij het toegang nemen van zijn/haar Account worden gevraagd om deze
                            gewijzigde Algemene voorwaarden Opdrachtgever te aanvaarden, dan wel er voor te opteren zich
                            uit te schrijven.
                        </li>
                    </ul>
                </li>
            </ol>
            <p>&nbsp;</p>
            <ol start="14">
                <li><u>Artikel 14 : Overmacht</u>
                    <ul>
                        <li>Connecting Care Professionals, noch de Opdrachtgever zal aansprakelijk zijn wegens
                            vertraging of tekortkoming in de uitvoering van de verbintenissen van de Algemene
                            Voorwaarden Opdrachtgever, indien deze vertraging of tekortkoming door overmacht in de zin
                            van het Burgerlijk Wetboek is ontstaan.
                        </li>
                        <li>In geval van bewezen overmacht zijn Connecting Care Professionals dan wel de Opdrachtgever
                            gerechtigd de nakoming van hun verplichtingen geheel of gedeeltelijk op te schorten voor de
                            duur van de overmacht, zonder tot enige schadevergoeding te kunnen worden verplicht.
                        </li>
                        <li>Indien de periode van overmacht langer dan 3 maanden heeft geduurd, of indien reeds bij
                            voorbaat vast staat dat die periode redelijkerwijze langer dan 3 maanden zal duren, is
                            Connecting Care Professionals dan wel de Opdrachtgever gerechtigd deze Algemene Voorwaarden
                            Opdrachtgever onmiddellijk bij aangetekend schrijven op te zeggen, zonder dat Connecting
                            Care Professionals ten opzichte van de Opdrachtgever tot enige schadevergoeding gehouden is.
                        </li>
                    </ul>
                </li>
            </ol>
        </>
    )
}